import { Card, Container } from 'react-bootstrap'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { history } from '../../..'
import FooterNew from '../Footer'

function SuccessNew() {
  const { t } = useTranslation()

  const handleNextButtonClick = () => {
    history.push('/auctions')
  }

  return (
    <>
      <Container fluid className='card-center card-background'>
        <Card style={{ width: '874px' }} className='newFont prevent-select card-shadow'>
          <Card.Header>
            <p className='login-card-title'>{t('payment_status')}</p>
          </Card.Header>
          <Card.Body className='card-padding font-status-size'>
            <div className='d-flex'>
              <i
                style={{ fontSize: '60px' }}
                className='fa-regular text-success fa-circle-check pe-3'
              />
              <h4 className='mt-2 fw-bolder text-black font-status-title-size'>{t('succesful')}</h4>
            </div>
            <p className='text-black pt-4'>{t('payment_accepted')}!</p>
            <div className='payment-buttons'>
              <button
                onClick={handleNextButtonClick}
                className='text-white payment-button-tryagain'
              >
                {t('next')}
              </button>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <FooterNew />
    </>
  )
}
export default observer(SuccessNew)
